import { Action } from "@ngrx/store";

export enum KwikspaceActionTypes {
  GET_PROVINCES = "[Provinces] Get Provinces",
  GET_PROVINCES_SUCCESS = "[Provinces] Get Provinces Success",
  GET_PROVINCES_FAILURE = "[Provinces] Get Provinces Error",

  GET_BUILDINGS = "[Buildings] Get Buildings",
  GET_BUILDINGS_SUCCESS = "[Buildings] Get Buildings Success",
  GET_BUILDINGS_FAILURE = "[Buildings] Get Buildings Error",

  GET_ORGANIZATIONS = "[Organizations] Get Organizations",
  GET_ORGANIZATIONS_SUCCESS = "[Organizations] Get Organizations Success",
  GET_ORGANIZATIONS_FAILURE = "[Organizations] Get Organizations Error",

  GET_LOCATIONS = "[Locations] Get Locations",
  GET_LOCATIONS_SUCCESS = "[Locations] Get Locations Success",
  GET_LOCATIONS_FAILURE = "[Locations] Get Locations Error",

  GET_VALIDITIES = "[Validities] Get Validities",
  GET_VALIDITIES_SUCCESS = "[Validities] Get Validities Success",
  GET_VALIDITIES_FAILURE = "[Validities] Get Validities Error",

  GET_SALES_REPS = "[Sales Reps] Get Sales Reps",
  GET_SALES_REPS_SUCCESS = "[Sales Reps] Get Sales Reps Success",
  GET_SALES_REPS_FAILURE = "[Sales Reps] Get Sales Reps Error",
}

export class GetProvinces implements Action {
  readonly type = KwikspaceActionTypes.GET_PROVINCES;
  constructor() { }
}

export class GetProvincesSuccess implements Action {
  readonly type = KwikspaceActionTypes.GET_PROVINCES_SUCCESS;
  constructor(public payload: any) { }
}

export class GetProvincesFailure implements Action {
  readonly type = KwikspaceActionTypes.GET_PROVINCES_FAILURE;
  constructor(public payload: any) { }
}

export class GetBuildings implements Action {
  readonly type = KwikspaceActionTypes.GET_BUILDINGS;
  constructor() { }
}

export class GetBuildingsSuccess implements Action {
  readonly type = KwikspaceActionTypes.GET_BUILDINGS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetBuildingsFailure implements Action {
  readonly type = KwikspaceActionTypes.GET_BUILDINGS_FAILURE;
  constructor(public payload: any) { }
}

export class GetOrganizations implements Action {
  readonly type = KwikspaceActionTypes.GET_ORGANIZATIONS;
  constructor() { }
}

export class GetOrganizationsSuccess implements Action {
  readonly type = KwikspaceActionTypes.GET_ORGANIZATIONS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetOrganizationsFailure implements Action {
  readonly type = KwikspaceActionTypes.GET_ORGANIZATIONS_FAILURE;
  constructor(public payload: any) { }
}

export class GetLocations implements Action {
  readonly type = KwikspaceActionTypes.GET_LOCATIONS;
  constructor() { }
}

export class GetLocationsSuccess implements Action {
  readonly type = KwikspaceActionTypes.GET_LOCATIONS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetLocationsFailure implements Action {
  readonly type = KwikspaceActionTypes.GET_LOCATIONS_FAILURE;
  constructor(public payload: any) { }
}

export class GetValidities implements Action {
  readonly type = KwikspaceActionTypes.GET_VALIDITIES;
  constructor() { }
}

export class GetValiditiesSuccess implements Action {
  readonly type = KwikspaceActionTypes.GET_VALIDITIES_SUCCESS;
  constructor(public payload: any) { }
}

export class GetValiditiesFailure implements Action {
  readonly type = KwikspaceActionTypes.GET_VALIDITIES_FAILURE;
  constructor(public payload: any) { }
}

export class GetSalesReps implements Action {
  readonly type = KwikspaceActionTypes.GET_SALES_REPS;
  constructor() { }
}

export class GetSalesRepsSuccess implements Action {
  readonly type = KwikspaceActionTypes.GET_SALES_REPS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetSalesRepsFailure implements Action {
  readonly type = KwikspaceActionTypes.GET_SALES_REPS_FAILURE;
  constructor(public payload: any) { }
}

export type KwikspaceActions =
  | GetProvinces
  | GetProvincesSuccess
  | GetProvincesFailure
  | GetBuildings
  | GetBuildingsSuccess
  | GetBuildingsFailure
  | GetOrganizations
  | GetOrganizationsSuccess
  | GetOrganizationsFailure
  | GetLocations
  | GetLocationsSuccess
  | GetLocationsFailure
  | GetValidities
  | GetValiditiesSuccess
  | GetValiditiesFailure
  | GetSalesReps
  | GetSalesRepsSuccess
  | GetSalesRepsFailure;
